<script setup lang="ts">
import { PageHeader } from '@/components/header'
import { useLocalization } from '@/plugins/localization'

const { t } = useLocalization()
</script>

<template>
  <PageHeader :title="t('unauthorized.title')" />
  <p>{{ t('unauthorized.body') }}</p>
  <p>{{ t('unauthorized.solution') }}</p>
</template>
